import React, { useRef, useState, useContext } from "react";
import { Modal, Button, Nav } from "react-bootstrap";
import Select from "react-select";
import QRCode from "react-qr-code";
import { useReactToPrint } from "react-to-print";
import { BASE_URL } from "../../../../../BaseUrl";
import { RestaurantContext } from "../../../../../contexts/Restaurant";

const MenuQRModal = ({ show, onHide, branchId, branchName }) => {
  const { deptTagForSearch} = useContext(RestaurantContext);
  const [activeTab, setActiveTab] = useState("menu");
  const [selectedMenu, setSelectedMenu] = useState(null);
  const [selectedOrderType, setSelectedOrderType] = useState("Takeaway");
  const [qrPrintItem, setQrPrintItem] = useState(null);
  const qrPrintRef = useRef(null);

  // Filter departments for this branch
  const departmentOptions = (deptTagForSearch || [])
    .filter((deptTag) => {
      if (!deptTag.branch_id) return false;
      return JSON.parse(deptTag.branch_id).includes(parseInt(branchId));
    });
  const handlePrintAction = useReactToPrint({
    content: () => qrPrintRef.current,
  });

  const handlePrintQr = () => {
    if (!selectedMenu?.name) return;
    if (activeTab === "orderType" && !selectedOrderType) return;

    const isOrderType = activeTab === "orderType";
    setQrPrintItem({
      branch_id: branchId,
      branch_name: branchName,
      menu_name: selectedMenu.name,
      order_type_name: isOrderType ? selectedOrderType : null,
      is_order_type: isOrderType,
    });
    setTimeout(() => {
      handlePrintAction();
    }, 100);
  };

  const handleClose = () => {
    setSelectedMenu(null);
    setSelectedOrderType("Takeaway");
    setQrPrintItem(null);
    setActiveTab("menu");
    onHide();
  };

  const getQRValue = (item) => {
    if (item.is_order_type && item.order_type_name) {
      return `${BASE_URL}/digital-menu/${item.branch_id}/M-${item.menu_name}/${item.order_type_name}`;
    }
    return `${BASE_URL}/digital-menu/${item.branch_id}/M-${item.menu_name}`;
  };

  const isGenerateDisabled = !selectedMenu || (activeTab === "orderType" && !selectedOrderType);

  return (
    <>
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="mb-0 xslg-text font-weight-bold">View Branch Menus</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Nav variant="pills" className="nav-justified mb-4" style={{ backgroundColor: "#f8f9fa", borderRadius: "8px", padding: "4px" }}>
            <Nav.Item>
              <Nav.Link 
                active={activeTab === "menu"} 
                onClick={() => { setActiveTab("menu"); setQrPrintItem(null); }}
                className={`font-weight-bold ${activeTab === "menu" ? "shadow-sm" : "text-muted"}`}
                style={{ borderRadius: "6px", cursor: "pointer" }}
              >
                Menu
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link 
                active={activeTab === "orderType"} 
                onClick={() => { 
                  setActiveTab("orderType"); 
                  setSelectedOrderType("Takeaway");
                  setQrPrintItem(null);
                }}
                className={`font-weight-bold ${activeTab === "orderType" ? "shadow-sm" : "text-muted"}`}
                style={{ borderRadius: "6px", cursor: "pointer" }}
              >
                Order Type
              </Nav.Link>
            </Nav.Item>
          </Nav>

          {activeTab === "menu" && (
            <div className="form-group mb-3">
              <label className="form-label font-weight-md text-muted">Select Menu</label>
              <Select
                options={departmentOptions}
                getOptionLabel={(option) => option.name}
                getOptionValue={(option) => option.id}
                value={selectedMenu}
                onChange={(selected) => {
                  setSelectedMenu(selected);
                  setQrPrintItem(null);
                }}
                placeholder="Select a menu..."
                styles={{
                  control: (base) => ({
                    ...base,
                    borderRadius: "8px",
                    borderColor: "#e2e8f0",
                    boxShadow: "none",
                    "&:hover": { borderColor: "#cbd5e1" }
                  })
                }}
              />
            </div>
          )}

          {activeTab === "orderType" && (
            <>
              <div className="form-group mb-3">
                <label className="form-label font-weight-md text-muted">Select Menu</label>
                <Select
                  options={departmentOptions}
                  getOptionLabel={(option) => option.name}
                  getOptionValue={(option) => option.id}
                  value={selectedMenu}
                  onChange={(selected) => {
                    setSelectedMenu(selected);
                    setQrPrintItem(null);
                  }}
                  placeholder="Select a menu..."
                  styles={{
                    control: (base) => ({
                      ...base,
                      borderRadius: "8px",
                      borderColor: "#e2e8f0",
                      boxShadow: "none",
                      "&:hover": { borderColor: "#cbd5e1" }
                    })
                  }}
                />
              </div>

              <div className="form-group mb-3 text-center">
                <label className="form-label font-weight-md text-muted d-block mb-3">Select Order Type</label>
                <Button 
                  variant={selectedOrderType === "Takeaway" ? "primary" : "outline-primary"}
                  onClick={() => {
                    setSelectedOrderType((prev) => (prev === "Takeaway" ? null : "Takeaway"));
                    setQrPrintItem(null);
                  }}
                  className={`px-4 py-2 ${selectedOrderType === "Takeaway" ? "shadow-sm" : ""}`}
                  style={{ borderRadius: "8px", fontWeight: "500", minWidth: "150px" }}
                >
                  Takeaway
                </Button>
              </div>
            </>
          )}

          {qrPrintItem && (
            <div className="text-center mt-4 mb-2 p-3 bg-light" style={{ borderRadius: "12px" }}>
              <div className="d-flex justify-content-center mb-3">
                <div className="p-3 bg-white shadow-sm" style={{ borderRadius: "12px" }}>
                  <QRCode
                    value={getQRValue(qrPrintItem)}
                    size={130}
                  />
                </div>
              </div>
              <p className="mb-0 text-muted">
                Scan to view <strong>{qrPrintItem.menu_name}</strong> {qrPrintItem.is_order_type && qrPrintItem.order_type_name ? `(${qrPrintItem.order_type_name})` : ""}
              </p>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className="border-0 pt-0">
          <Button variant="light rounded-sm font-weight-md" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary rounded-sm font-weight-md shadow-sm" onClick={handlePrintQr} disabled={isGenerateDisabled}>
            Generate & Print QR
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Hidden Print Container */}
      <div className="d-none">
        <div ref={qrPrintRef}>
          {qrPrintItem && (
            <div className="container-fluid" style={{ marginTop: "20px" }}>
              <div className="row">
                <div className="col-12 text-center">
                  <div className="d-flex justify-content-center">
                    <QRCode
                      value={getQRValue(qrPrintItem)}
                      size={120}
                    />
                  </div>
                  <div className="mt-3 text-capitalize font-weight-md text-center">
                    Branch: {qrPrintItem.branch_name}
                    <br />
                    Menu: {qrPrintItem.menu_name}
                    {qrPrintItem.is_order_type && qrPrintItem.order_type_name && (
                      <>
                        <br />
                        Order Type: {qrPrintItem.order_type_name}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default MenuQRModal;
